import { BASE_URL } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  PATCH: 'STUDENTS_PATCH',
  PATCH_SUCCESS: 'STUDENTS_PATCH_SUCCESS',
  PATCH_FAILURE: 'STUDENTS_PATCH_FAILURE',
};

export const patch = actions.patch(studentId => `${BASE_URL}/students/${studentId}/`, {
  PENDING: ACTIONS.PATCH,
  SUCCESS: ACTIONS.PATCH_SUCCESS,
  FAILURE: ACTIONS.PATCH_FAILURE,
});
